var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EGiftCardPurchaseAttemptStatus, HttpGiftCardPurchaserService, } from "../infrastructure/HttpGiftCardPurchaserService";
var GiftCardPurchaser = /** @class */ (function () {
    function GiftCardPurchaser() {
        Object.defineProperty(this, "httpGiftCardPurchaserService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new HttpGiftCardPurchaserService()
        });
        Object.defineProperty(this, "cancelIsPurchasing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "cancelGet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    Object.defineProperty(GiftCardPurchaser.prototype, "initAttempt", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.httpGiftCardPurchaserService.initAttempt()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
    });
    Object.defineProperty(GiftCardPurchaser.prototype, "isPurchasing", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var intervalMs;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.cancelIsPurchasing = false;
                            intervalMs = 5000;
                            return [4 /*yield*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    var _this = this;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, new Promise(function (_resolve) {
                                                    return setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0: return [4 /*yield*/, this.httpGiftCardPurchaserService.getAttempt(id)];
                                                                case 1:
                                                                    response = _a.sent();
                                                                    _resolve(null);
                                                                    return [2 /*return*/];
                                                            }
                                                        });
                                                    }); }, intervalMs);
                                                })];
                                            case 1:
                                                _a.sent();
                                                _a.label = 2;
                                            case 2:
                                                if (!this.cancelIsPurchasing && response && response.status === EGiftCardPurchaseAttemptStatus.CREATED) return [3 /*break*/, 0];
                                                _a.label = 3;
                                            case 3:
                                                if (!response) {
                                                    return [2 /*return*/, resolve(false)];
                                                }
                                                return [2 /*return*/, resolve(true)];
                                        }
                                    });
                                }); })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
    });
    Object.defineProperty(GiftCardPurchaser.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var intervalMs;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            intervalMs = 5000;
                            this.cancelGet = false;
                            return [4 /*yield*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    var _this = this;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.httpGiftCardPurchaserService.getAttempt(id)];
                                            case 1:
                                                response = _a.sent();
                                                if (!(!response || response.status !== EGiftCardPurchaseAttemptStatus.COMPLETED)) return [3 /*break*/, 5];
                                                _a.label = 2;
                                            case 2: return [4 /*yield*/, new Promise(function (_resolve) {
                                                    return setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0: return [4 /*yield*/, this.httpGiftCardPurchaserService.getAttempt(id)];
                                                                case 1:
                                                                    response = _a.sent();
                                                                    _resolve(null);
                                                                    return [2 /*return*/];
                                                            }
                                                        });
                                                    }); }, intervalMs);
                                                })];
                                            case 3:
                                                _a.sent();
                                                _a.label = 4;
                                            case 4:
                                                if (!this.cancelGet && response && response.status !== EGiftCardPurchaseAttemptStatus.COMPLETED) return [3 /*break*/, 2];
                                                _a.label = 5;
                                            case 5:
                                                if (!response) {
                                                    return [2 /*return*/, resolve(undefined)];
                                                }
                                                return [2 /*return*/, resolve(response.purchase || undefined)];
                                        }
                                    });
                                }); })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
    });
    Object.defineProperty(GiftCardPurchaser.prototype, "cancelPolling", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.cancelIsPurchasing = true;
            this.cancelGet = true;
        }
    });
    Object.defineProperty(GiftCardPurchaser.prototype, "isPollingCancelled", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.cancelIsPurchasing;
        }
    });
    Object.defineProperty(GiftCardPurchaser.prototype, "isGetCancelled", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.cancelGet;
        }
    });
    return GiftCardPurchaser;
}());
export { GiftCardPurchaser };
